// extracted by mini-css-extract-plugin
export default {"container":"home_container__JKgjJ"};